import { createGlobalStyle, css } from "styled-components";
import { ThemeTypographies } from "./types";

export const elementStyles = (elementType: keyof ThemeTypographies) => css`
  ${({ theme }) => `
    font-size: ${theme.typography[elementType]?.fontSize?.xs};
    line-height: ${theme.typography[elementType]?.lineHeight?.xs};
    font-weight: ${theme.typography[elementType]?.fontWeight};

    ${theme.typography[elementType]?.fontSize?.sm && theme.breakpoint('sm', 'up')(`
      font-size: ${theme.typography[elementType]?.fontSize?.sm};
      line-height: ${theme.typography[elementType]?.lineHeight?.sm};
    `)}

    ${theme.typography[elementType]?.fontSize?.md && theme.breakpoint('md', 'up')(`
      font-size: ${theme.typography[elementType]?.fontSize?.md};
      line-height: ${theme.typography[elementType]?.lineHeight?.md};
    `)}

    ${theme.typography[elementType]?.fontSize?.lg && theme.breakpoint('lg', 'up')(`
      font-size: ${theme.typography[elementType]?.fontSize?.lg};
      line-height: ${theme.typography[elementType]?.lineHeight?.lg};
    `)}

    ${theme.typography[elementType]?.fontSize?.xl && theme.breakpoint('xl', 'up')(`
      font-size: ${theme.typography[elementType]?.fontSize?.xl};
      line-height: ${theme.typography[elementType]?.lineHeight?.xl};
    `)}
  `}
`;

const GlobalStyles = createGlobalStyle`
  h1, .h1 {
    ${elementStyles('h1')}
  }

  h2, .h2 {
    ${elementStyles('h2')}
  }

  h3, .h3 {
    ${elementStyles('h3')}
  }

  h4, .h4 {
    ${elementStyles('h4')}
  }

  h5, .h5 {
    ${elementStyles('h5')}
  }

  h6, .h6 {
    ${elementStyles('h6')}
  }

  p {
    ${elementStyles('body1')}
  }

  small {
    ${elementStyles('legal')}
  }

  button, .button{
    ${elementStyles('button')}
  }

`;

export default GlobalStyles;